// Records the short test video and plays it back. Never shows messages: the
// caller handles every rejection.
export class RecordingTester {
  recorder = null;
  videoElement = null;
  #objectURL = null;

  constructor(videoElement, recorder) {
    this.videoElement = videoElement;
    this.recorder = recorder;
  }

  // API :: INI
  // Shows the live preview and records. Resolves with the test video Blob.
  record(seconds) {
    this.showRecording();
    return this.recorder.record(seconds);
  }

  // Plays the test video back with sound. Returns the play() promise.
  play(blob) {
    if (this.#objectURL !== null) {
      URL.revokeObjectURL(this.#objectURL); // A14
    }

    this.#objectURL = URL.createObjectURL(blob);
    this.videoElement.srcObject = null;
    this.videoElement.src = this.#objectURL;
    this.videoElement.muted = false;
    return this.videoElement.play();
  }

  // Frames of the test video played so far: all of them once the replay
  // ended. Its duration is Infinity for a MediaRecorder WebM, so the caller
  // divides by the time it recorded (D4).
  playedFrames() {
    return this.videoElement.getVideoPlaybackQuality?.().totalVideoFrames ?? null;
  }
  // API :: END

  showRecording() {
    this.videoElement.srcObject = this.recorder.getFullStream();
    this.videoElement.muted = true;
    this.videoElement.play().catch((error) => console.warn("RecordingTester.showRecording()", error));
  }
}
